<template>
  <div>
    <div class="d-flex align-center">
      <v-file-input ref="file-input" v-model="uploadFile" :placeholder="$tc('select_a_file')" :error-messages="errors"/>
      <v-btn fab text :loading="uploading" color="primary" @click="fileUpload">
        <v-icon>mdi-upload</v-icon>
      </v-btn>
    </div>
    <div v-if="result" class="file-preview mt-2">
      <h6 class="mb-0 float-right font-italic">{{ $tc('preview') }}</h6>
      <v-data-table
        :headers="tableFields"
        :items="resultPreview">
        <template item.timestamp="row">
          <multi-time-display :time="row.value"/>
        </template>
        <template item.temperature_value="row">
          {{ temperatureToCustomerScale(row.value) }}
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay'
import ApiUtilitiesMixin from '@/components/mixins/ApiUtilitiesMixin'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import TemperatureMixin from '@/components/mixins/TemperatureMixin'
import { take } from 'lodash'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUpload } from '@fortawesome/free-solid-svg-icons'

library.add(faUpload)

export default {
  name: 'SensorFileUpload',
  props: {
    state: {
      type: Boolean,
      default: null
    },
    value: Array,
    customerId: Number,
    errors: {
      type: Array,
      default: () => []
    }
  },
  components: {
    MultiTimeDisplay
  },
  mixins: [
    ApiUtilitiesMixin,
    CurrentUserMixin,
    TemperatureMixin
  ],
  data () {
    return {
      uploadFile: null,
      uploading: false,
      result: null
    }
  },
  methods: {
    /**
     * Reset to the component's initial state
     */
    reset () {
      this.result = null
      this.$refs['file-input'].reset()
    },
    /**
     * Upload the file to the sensor file API endpoint, get the response, then emit the result.
     * @returns {Promise<void>}
     */
    async fileUpload () {
      const file = this.uploadFile
      this.uploading = true
      const fileReader = new FileReader()
      fileReader.readAsText(file)
      // Once this promise resolves, the file will be available as fileReader.result
      await new Promise(resolve => {
        fileReader.onload = resolve
      })
      try {
        const result = await this.$httpAdapter({
          headers: { 'Content-Type': 'text/csv' },
          url: this.$orm('VehicleData').endpoint + '/sensor-file?customer_id=' + this.customerId,
          method: 'POST',
          data: fileReader.result
        })
        this.result = result.data
        this.$emit('input', result.data)
      } catch (error) {
        this.renderErrorModal(error)
        throw (error)
      } finally {
        this.uploading = false
      }
    }
  },
  computed: {
    /**
     * Just show the first 5 results from the API as a preview
     */
    resultPreview () {
      return take(this.result, 5)
    },
    tableFields () {
      return [
        {
          value: 'timestamp',
          text: this.$tc('timestamp')
        },
        {
          value: 'temperature_value',
          text: this.$t('temperature_with_format', { format: this.customerContext.tempFormat() })
        }
      ]
    }
  }
}
</script>

<style scoped>
.file-preview {
  border-radius: 5px;
  border: 1px solid #ddd;
  background-color: #eee;
  color: #555;
  padding: 10px;
}
.file-preview h6 {
  color: #aaa;
}
</style>
